









import { Component, Vue } from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
@Component({
  components: {
    PageTitle,
    AdminIframe,
  },
})
export default class OrderProductPrepareIframe extends Vue {
  private get remoteSrc() {    const queryObject = { ...this.$route.query, serviceType: 'PREMIUM' };
    const queryString = new URLSearchParams(queryObject).toString();
    return process.env.VUE_APP_ADMIN_REMOTE_URL + '/fulfillment/order/product-prepare?' + queryString;
  }
}
